/*
 * Token used for dependency injection of the logger.
 */
export const ACOUSTIC_RC_INTERCEPTOR_TOKEN = '8453750A-4519-4184-840B-D490E909D23E';
